// authService.js

export const login = (email, password) => {
    if (email === 'testing123@gmail.com' && password === 'test') {
      // Store user authentication status in localStorage
      localStorage.setItem('isAuthenticated', 'true');
      return true;
    }
    return false;
  };
  
  export const logout = () => {
    localStorage.removeItem('isAuthenticated');
  };
  
  export const isAuthenticated = () => {
    return localStorage.getItem('isAuthenticated') === 'true';
  };
  